import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import InboundIpAddresses from '../../_snippets/inbound-ip-addresses.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The MySQL connector can link your database tables to PostHog.`}</p>
    <p>{`To link MySQL:`}</p>
    <ol>
      <li parentName="ol">{`Go to the `}<a parentName="li" {...{
          "href": "https://us.posthog.com/pipeline/sources"
        }}>{`Data pipeline page`}</a>{` and the sources tab in PostHog`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`New source`}</strong>{` and select MySQL`}</li>
      <li parentName="ol">{`Enter your database connection details:`}
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`Host:`}</strong>{` The hostname or IP your database server like `}<inlineCode parentName="li">{`db.example.com`}</inlineCode>{` or `}<inlineCode parentName="li">{`123.132.1.100`}</inlineCode>{`.`}</li>
          <li parentName="ul"><strong parentName="li">{`Port:`}</strong>{` The port your database server is listening to. The default is `}<inlineCode parentName="li">{`3306`}</inlineCode>{`.`}</li>
          <li parentName="ul"><strong parentName="li">{`Database:`}</strong>{` The name of the database you want like `}<inlineCode parentName="li">{`analytics_db`}</inlineCode>{`.`}</li>
          <li parentName="ul"><strong parentName="li">{`User:`}</strong>{` The username with the necessary permissions to access the database.`}</li>
          <li parentName="ul"><strong parentName="li">{`Password:`}</strong>{` The password for the user.`}</li>
          <li parentName="ul"><strong parentName="li">{`Schema:`}</strong>{` The schema for your database where your tables are located. The default is `}<inlineCode parentName="li">{`public`}</inlineCode>{`.`}</li>
          <li parentName="ul"><strong parentName="li">{`Use SSL:`}</strong>{` Whether to use SSL for the connection. Default is enabled.`}</li>
        </ul>
      </li>
      <li parentName="ol">{`If you need to connect through an SSH tunnel, enable and configure it (optional):`}
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`Tunnel host:`}</strong>{` The hostname of your SSH server.`}</li>
          <li parentName="ul"><strong parentName="li">{`Tunnel port:`}</strong>{` The port your SSH server is listening on.`}</li>
          <li parentName="ul"><strong parentName="li">{`Authentication type:`}</strong>
            <ul parentName="li">
              <li parentName="ul">{`For password authentication, enter your SSH username and password.`}</li>
              <li parentName="ul">{`For key-based authentication, enter your SSH username, private key, and optional passphrase.`}</li>
            </ul>
          </li>
        </ul>
      </li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Next`}</strong></li>
    </ol>
    <p>{`The data warehouse then starts syncing your MySQL data. You can see details and progress in the `}<a parentName="p" {...{
        "href": "https://us.posthog.com/pipeline/sources"
      }}>{`sources tab`}</a>{`.`}</p>

    <InboundIpAddresses mdxType="InboundIpAddresses" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      